import React from "react";

import ReportCard from "../../components/ui/ReportCard";

import query from "../../images/frame.png";

export default function QueriedReports({ report }) {
  return <ReportCard title="Queried Reports" text={report} src={query} />;
}
